import api from "../Component/api/api";

const upload = async (files) => {
  let formData = new FormData();
  for (const file of files) {
    await formData.append("file_upload", file);
  }
  const result = await api.post(`/api/upload/file`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return result;
};

const uploadFileForBvoice = async (files) => {
  let _result = [];
  for (const file of files) {
    let formData = new FormData();

    await formData.append("file_upload", file);
    const result = await api.post(`/api/upload/file`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    _result.push(result);
  }

  return _result;
};

const uploadExcel = async (files) => {
  let formData = new FormData();
  for (const file of files) {
    formData.append("file_upload", file);
  }
  const result = await api.post(`/api/bpoint/employee/point/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result;
};

const uploadExcelCatagoly = async (files) => {
  let formData = new FormData();
  for (const file of files) {
    formData.append("menu", file);
  }
  const result = await api.post(`/api/setting/menu/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return result;
};

export default {
  upload,
  uploadFileForBvoice,
  uploadExcel,
  uploadExcelCatagoly,
};
